import { useQuery } from '@tanstack/react-query'

import { QUERY_KEYS } from 'constants/constants'
import { query } from '../graphql'
import { isSet } from '../helpers'

export const useMatchMeIfYouCanQuery = ({ talentId, partnerId, options }) => {
  return useQuery({
    queryKey: QUERY_KEYS.matchMeIfYouCan(talentId, partnerId),
    queryFn: () =>
      query({
        query: 'matchMeIfYouCan',
        variables: { partner_id: partnerId, user_id: talentId }
      }),
    select: (response) => {
      const res = JSON.parse(response)
      const result = res.filter(
        (c) =>
          c.status === 'ACTIVE' &&
          (isSet(c.matching_score) || isSet(c.matching_score_to_career))
      )

      return result
    },
    ...options
  })
}
